<template lang="pug">
.RakugoPlayer
  km-countdown-overlay(
    :messages="['噺家になろう','その1', this.title]"
    color="rgba(82, 18, 119, 0.9)"
    font="inherit"
    @onFinished="handleCountdownFinished"
  )
  .content
    km-keyboard-input.input(
      :targetText="isReady ? this.targetText : null"
      :targetPreviewText="isReady ? '' : ''"
      :testRepeatCount="0"
      :lock="keyboardInputLock"
      @onInput="handleInput"
      @onCorrectInput="handleCorrectInput"
      @onInputFinished="handleInputFinished"
      @onMissInput="handleMissInput"
    )
    transition(name="slide")
      .score(:key="score") {{ score | zeroPadding }} 点

    //- transition(name="rollpop" duration="600")
    //-   .scorePopup(:key="plusScore" v-if="plusScore") +{{plusScore}} {{ chainCount > 1 ? `${chainCount}連続!` : '' }}
    //- .remainCount
    //-   | あと
    //-   span.number {{ remainCount }}
    //-   | つ
    .targetList
    .character
    .crowds
      transition(name="fade")
        .people_1(v-if="completeRatio >= 10"): img(src="@/assets/speedup/rakugo/people_1.png")
      transition(name="fade")
        .people_2(v-if="completeRatio >= 20"): img(src="@/assets/speedup/rakugo/people_2.png")
      transition(name="fade")
        .people_3(v-if="completeRatio >= 40"): img(src="@/assets/speedup/rakugo/people_3.png")
      transition(name="fade")
        .people_4(v-if="completeRatio >= 60"): img(src="@/assets/speedup/rakugo/people_4.png")
      transition(name="fade")
        .people_5(v-if="completeRatio >= 80"): img(src="@/assets/speedup/rakugo/people_5.png")
    //- .endMessage(:class="{ hidden: !isFinished }") そこまで！
    .subtitles(v-html="subtitles")
    .notice
      | {{ notice }}
      a(v-if="noticeUrl" :href="noticeUrl" target="_blank") URL:{{noticeUrl}}
    .background
    .debug(v-if="constants.IS_DEBUG")
      | chain: {{ chainCount }}/
      | maxChain: {{ maxChainCount }}/
      | totalCharacter: {{ totalCharacterSize }}/
      | inputCharacter: {{ inputCharacterCount }}/
      | completeRatio: {{ completeRatio }} /
      | time: {{ time }} /

  km-footer(
    backPath="/speedup/rakugo/select"
    title="噺家になろう"
  )
</template>

<script>
import { mapActions } from 'vuex'
import * as _ from 'lodash'
import * as constants from '@/constants'
import soundService from '@/services/SoundService'
import KeyboardInput from '@/components/speedUp/rakugo/KeyboardInput'
import CountdownOverlay from '@/components/shared/CountdownOverlay'

export default {
  name: 'speedup-rakugo-play-page',
  components: {
    'km-keyboard-input': KeyboardInput,
    'km-countdown-overlay': CountdownOverlay
  },
  filters: {
    zeroPadding(value) {
      return ('00000000' + value).slice(-8)
    }
  },
  data() {
    return {
      constants,
      isReady: false,
      isFinished: false,
      keyboardInputLock: false,
      level: '',
      MAX_REPEAT: 0,
      isRepeat: false,
      speechCount: 0,
      score: 0,
      plusScore: 0,
      speed: 1,
      title: '',
      chainCount: 0,
      maxChainCount: 0,
      time: 0,
      texts: [
        // {
        //   speechText: 'じゅげむじゅげむ、ごこうのすりきれ',
        //   text: ['じゅげむじゅげむ', 'ごこうのすりきれ']
        // }
      ],
      notice: '',
      noticeUrl: '',
      targetIndex: 0,
      targetText: [],
      inputCharacterCount: 0,
      totalInputCharacterCount: 0,
      missCount: 0,
      timerInstance: null,
      soundInstance: null,
      speechFinishedDelayTimer: null,
      finishedIndexes: []
    }
  },
  computed: {
    currentText() {
      return this.texts[this.targetIndex]
    },
    subtitles() {
      if (!this.currentText) return ''
      if (this.currentText.labelText) return this.currentText.labelText
      if (this.currentText.speechText) return this.currentText.speechText
      return ''
    },
    totalCharacterSize() {
      const text = this.texts
        .map(textItem => {
          return textItem.text.join()
        })
        .join()
      return text.length
    },
    remainCount() {
      return this.texts.length - this.targetIndex
    },
    completeRatio() {
      return this.texts.length * 100
    }
  },
  mounted() {
    this.stopBGM()
    this.level = this.$route.params.level
    this.initSound()
    this.loadSettings()
  },
  beforeDestroy() {
    soundService.stopSpeech()
  },
  /**
   *
   */
  methods: {
    ...mapActions('Sound', ['playBGM', 'stopBGM']),
    ...mapActions('User/SpeedUp/Rakugo', ['setResult']),
    updateChainCount() {
      this.chainCount++
      if (this.chainCount > this.maxChainCount)
        this.maxChainCount = this.chainCount
    },
    addScore() {
      const score =
        Math.pow(this.chainCount, 3) / (this.time !== 0 ? this.time : 1)
      this.plusScore = score ? score.toFixed() : 0
      this.score += parseInt(this.plusScore)
    },
    finish() {
      this.isFinished = true
      soundService.stopSpeech()

      // play crowd sound
      switch (true) {
        case this.completeRatio <= 50:
          break
        case this.completeRatio <= 75:
          soundService.playCustomSound('end_1', this.soundInstance)
          break
        default:
          soundService.playCustomSound('end_2', this.soundInstance)
          break
      }
      this.setResult({
        level: this.level,
        score: this.score,
        time: this.time,
        missCount: this.missCount
      })
      setTimeout(() => {
        this.$router.push(`/speedUp/rakugo/result/${this.level}`)
      }, 2000)
    },
    setNextText() {
      this.targetIndex++
      this.targetText = this.texts[this.targetIndex].text
    },
    next() {
      const isLast = this.texts.length === this.targetIndex + 1
      if (isLast) {
        this.finish()
        return
      }
      this.speechCount = 0
      this.totalInputCharacterCount += this.inputCharacterCount
      this.setNextText()
      this.speak()
      this.keyboardInputLock = false
      this.inputCharacterCount = 0
    },
    async speak() {
      await soundService.stopSpeech()
      this.speechCount++
      let capturedTargetIndex = this.targetIndex
      await soundService.speak(
        this.texts[this.targetIndex].speechText,
        this.speed
      )
      this.handleSpeechFinished(capturedTargetIndex)
    },
    start() {
      this.timerInstance = setInterval(() => {
        this.time += 1
      }, 1000)
      this.targetText = this.texts[this.targetIndex].text
      this.speak()
      this.isReady = true
    },
    initSound() {
      this.soundInstance = soundService.initCustomInstance({
        end_1: {
          type: 'effect',
          fileName: '/app/static/speedup/rakugo/end_1.mp3',
          volume: 1
        },
        end_2: {
          type: 'effect',
          fileName: '/app/static/speedup/rakugo/end_2.mp3',
          volume: 1
        },
        laugh_small: {
          type: 'effect',
          fileName: '/app/static/speedup/rakugo/laugh_small.mp3',
          volume: 1
        },
        laugh_normal: {
          type: 'effect',
          fileName: '/app/static/speedup/rakugo/laugh_normal.mp3',
          volume: 1
        },
        laugh_large: {
          type: 'effect',
          fileName: '/app/static/speedup/rakugo/laugh_large.mp3',
          volume: 1
        }
      })
    },
    async loadSettings() {
      // embedded
      const settings = await (
        await fetch('/app/static/json/settings.json', { cache: 'no-store' })
      ).json()
      await fetch(
        `/app/static/json/speedup/rakugo/${
          settings.speedup.rakugo[this.level]
        }.json`,
        { cache: 'no-store' }
      )
        .then(async response => {
          const data = await response.json()
          this.title = data.title
          this.notice = data.notice
          this.noticeUrl = data.noticeUrl
          this.texts = data.texts
          this.speed = data.speed
          this.MAX_REPEAT = data.repeatCount
          this.isRepeat = data.repeatCount > 0
        })
        .catch(() => {
          alert('問題読み込みエラー')
          if (!this.embedded) this.$router.push('/')
        })
    },
    handleInput(correctInputCharacterCount) {
      this.inputCharacterCount = correctInputCharacterCount
    },
    handleCorrectInput(isConverted) {
      if (!isConverted) return
      this.updateChainCount()
      this.addScore()
    },
    handleMissInput() {
      this.chainCount = 0
    },
    handleInputFinished() {
      if (_.indexOf(this.finishedIndexes, this.targetIndex) >= 0) return
      this.finishedIndexes.push(this.targetIndex)
      this.keyboardInputLock = true
      if (this.speechFinishedDelayTimer) {
        clearTimeout(this.speechFinishedDelayTimer)
        this.speechFinishedDelayTimer = null
      }
      // play sound
      switch (true) {
        case this.completeRatio <= 25:
          soundService.playCustomSound('laugh_small', this.soundInstance)
          break
        case this.completeRatio <= 50:
          soundService.playCustomSound('laugh_normal', this.soundInstance)
          break
        default:
          soundService.playCustomSound('laugh_large', this.soundInstance)
          break
      }
      this.next()
    },
    handleSpeechFinished(capturedTargetIndex) {
      if (this.$route.name !== 'speedup-rakugo-player-page') return
      if (_.indexOf(this.finishedIndexes, capturedTargetIndex) >= 0) return
      this.speechFinishedDelayTimer = setTimeout(() => {
        if (this.isRepeat && this.speechCount < this.MAX_REPEAT) {
          this.speak()
        } else {
          this.finishedIndexes.push(this.targetIndex)
          this.keyboardInputLock = true
          this.next()
        }
      }, 500)
    },
    handleCountdownFinished() {
      this.start()
    }
  }
}
</script>

<style lang="scss" scoped>
.RakugoPlayer {
  width: 100%;
  height: 100%;
  background: #000;
  color: #fff;
}

.content {
  position: relative;
  display: flex;
  justify-content: center;
  width: 100%;
  height: calc(100% - 80px);
  font-size: 3rem;
}

.time {
  position: absolute;
  left: 0;
  top: 0;
  color: #fff;
  z-index: 200;
}

.scorePopup {
  position: absolute;
  left: calc(50% - 150px);
  top: 80px;
  width: 300px;
  color: yellow;
  font-weight: bold;
  text-align: center;
  text-shadow: 0 0 10px rgba(0, 0, 0, 1);
  transform: rotate(-7deg);
  opacity: 0;
  z-index: 200;
}

.score {
  position: absolute;
  left: calc(50% - 150px);
  top: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 300px;
  height: 80px;
  color: #333;
  font-weight: bold;
  z-index: 200;

  .number {
    color: rgba(82, 18, 119, 1);
  }
}

.chain {
  position: absolute;
  right: 100px;
  bottom: 100px;
  display: flex;
  width: 10px;
  white-space: pre-wrap;
  justify-content: center;
  align-items: center;
  color: #333;
  font-weight: bold;
  z-index: 200;

  .number {
    color: rgba(82, 18, 119, 1);
  }
}

.remainCount {
  position: absolute;
  left: calc(50% - 150px);
  top: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 300px;
  height: 80px;
  color: #333;
  z-index: 200;

  .number {
    color: rgba(82, 18, 119, 1);
  }
}

.input {
  position: absolute;
  top: 230px;
  z-index: 200;
}

.crowds {
  position: absolute;
  bottom: 0;
  left: calc(50% - 487px);
  width: 975px;
  z-index: 300;

  .people_1,
  .people_2,
  .people_3,
  .people_4,
  .people_5 {
    position: absolute;
    bottom: 0;
    width: 975px;
    text-align: center;
  }

  .people_1 {
    z-index: 305;
  }

  .people_2 {
    z-index: 304;
    img {
      margin-left: -50px;
    }
  }

  .people_3 {
    z-index: 303;

    img {
      margin-left: 240px;
    }
  }

  .people_4 {
    z-index: 302;
  }

  .people_5 {
    z-index: 300;
    img {
      margin-left: -50px;
    }
  }

  img {
    vertical-align: bottom;
  }
}

.subtitles {
  position: absolute;
  bottom: 60px;
  z-index: 350;
}

.notice {
  position: absolute;
  right: 205px;
  bottom: 5px;
  font-size: 1rem;
  z-index: 350;

  a {
    color: #fff;
  }
}

.background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: url(../../../assets/speedup/rakugo/bg.png) no-repeat;
  background-position: center;
  background-size: contain;
}

.character {
  position: absolute;
  top: 49%;
  left: 47%;
  width: calc(114px * 0.75);
  height: calc(199px * 0.75);
  background: url(../../../assets/speedup/rakugo/hanashika.png) no-repeat;
  background-size: cover;
  z-index: 100;
}

.endMessage {
  position: fixed;
  top: calc(50% - 100px);
  left: calc(50% - 300px);
  display: flex;
  justify-content: center;
  align-items: center;
  width: 600px;
  height: 150px;
  border: 10px solid red;
  color: red;
  background: #fff;
  font-size: 60px;
  font-weight: bold;
  font-family: serif;
  opacity: 1;
  transform: scale(1.5) rotate(-15deg);
  transition-property: transform, opacity;
  z-index: 300;

  &.hidden {
    transform: scale(0.5);
    opacity: 0;
  }
}

.debug {
  position: fixed;
  right: 0;
  bottom: 0;
  color: #fff;
}
</style>
